import React, { lazy } from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { EbookCarousel } from './EbookCarousel';
import { Section } from './Shared';
import { Mandala } from './HealingIcons';
import { Pricing } from './Pricing';
const bonuses = [{
  n: '01',
  title: 'El Canal del Infinito',
  description: 'Fisiología Energética y Reloj Biológico de los Meridianos',
  price: '$15.000',
  cover: 'https://cdn.magicpatterns.com/uploads/xxE1tfYm5krR7XEt4DcFGY/Portadaa_bono_1.png'
}, {
  n: '02',
  title: 'Psicosomática Oriental',
  description: 'El Mapa de las Emociones Atrapadas y los 5 Elementos',
  price: '$15.000',
  cover: 'https://cdn.magicpatterns.com/uploads/nxGNxRFdnMocPukjpDhErK/Portadaa_bono_2.png'
}, {
  n: '03',
  title: 'Maestría en Manipulación',
  description: 'Ciencia, Intención y Técnica de la Presión Energética',
  price: '$12.000',
  cover: 'https://cdn.magicpatterns.com/uploads/ceTrXq9do64t8B6UrhdAZm/Portadaa_bono_3.png'
}, {
  n: '04',
  title: 'Alquimia a través del Calor',
  description: 'Termoterapia y Moxibustión aplicada a los Puntos Maestros',
  price: '$12.000',
  cover: 'https://cdn.magicpatterns.com/uploads/9LSo774knV69Grq5kdKtiT/Portadaa_bono_4.png'
}, {
  n: '05',
  title: 'Auriculoterapia Clínica',
  description: 'El Microsistema del Pabellón Auricular: El mando a distancia de tu salud',
  price: '$12.000',
  cover: 'https://cdn.magicpatterns.com/uploads/ofYtwTvd3BZZ6cSg9dQotR/Portadaa_bono_5.png'
}, {
  n: '06',
  title: 'Farmacopea Externa',
  description: 'Sinergia Holística: Aceites Esenciales y Plantas aplicadas a los Puntos Maestros',
  price: '$10.000',
  cover: 'https://cdn.magicpatterns.com/uploads/iD81krjQxLfnCnFpAMT2E7/Portadaa_bono_6.png'
}];
export function PackContents() {
  return <Section id="method" className="relative" data-id="element-189" data-mp="338ceqmbdrm7v">
      <Mandala className="absolute -left-16 top-20 -z-10 h-52 w-52 opacity-10" color="#2E5946" data-id="element-190" data-mp="3395e3280f9fz" />
      <div className="mx-auto max-w-5xl text-center" data-id="element-191" data-mp="1349wjey6oret">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-brand-gold/55 bg-brand-paper px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-forest shadow-sm" data-id="element-192" data-mp="y8ksozf4socp">
          <BookOpenIcon className="h-3.5 w-3.5 text-brand-goldDark" aria-hidden="true" data-id="element-193" data-mp="184xllv2uqy6e" />
          Mirá el ebook por dentro
        </span>
        <h2 className="mt-2 font-display text-[28px] font-bold leading-[0.82] text-brand-ink sm:text-4xl md:text-5xl" data-id="element-194" data-mp="1hw20kusj2j18">
          Sin vueltas, sin fármacos:{' '}
          <span className="relative z-0 inline-block px-1.5 text-brand-purpleDark before:absolute before:inset-x-0 before:bottom-[0.06em] before:-z-10 before:h-[0.42em] before:-rotate-1 before:rounded-sm before:bg-brand-goldLight/90" data-id="element-195" data-mp="1vt7ax6z9y42a">
            alivio real y natural
          </span>{' '}
          al alcance de tus dedos.
        </h2>
      </div>
      <div className="mx-auto mt-4 grid max-w-5xl items-start gap-8 rounded-3xl border border-brand-green/25 bg-brand-paper/80 p-5 shadow-[0_14px_40px_rgba(34,54,70,0.08)] md:grid-cols-[0.8fr_1.2fr] md:p-8" data-id="element-196" data-mp="2859j77gkigvi">
        <EbookCarousel data-id="element-197" data-mp="1yeoi9ddf909f" />
        <div className="flex flex-col justify-center" data-id="element-198" data-mp="1yfg6g34ovvpo">
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-purple" data-id="element-199" data-mp="23e17g4rrmjf6">
            Ebook principal
          </span>
          <h3 className="mt-1 font-serif text-3xl font-bold leading-none text-brand-ink" data-id="element-200" data-mp="1pdqfszimt0sy">
            EL BOTIQUÍN ANCESTRAL™
          </h3>
          <p className="mt-3 max-w-lg font-serif text-lg leading-snug text-brand-text" data-id="element-201" data-mp="1fh3vqcy4qdrz">
            Tu atlas visual para encontrar el punto exacto y aplicarlo con
            seguridad.
          </p>
          <div className="mt-5 grid grid-cols-3 divide-x divide-brand-gold/35 rounded-2xl border border-brand-gold/35 bg-brand-surfaceLight/45 px-2 py-3 text-center" data-id="element-202" data-mp="39v4ukxtoj0s2">
            <div className="px-2" data-id="element-203" data-mp="3ervho53wiwmz">
              <strong className="block font-serif text-xl leading-none text-brand-forest" data-id="element-204" data-mp="1es8gekflffnu">
                60
              </strong>
              <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.12em] text-brand-muted" data-id="element-205" data-mp="1arg4tkj90yoe">
                páginas
              </span>
            </div>
            <div className="px-2" data-id="element-206" data-mp="10sqm5pjj3a73">
              <strong className="block font-serif text-xl leading-none text-brand-forest" data-id="element-207" data-mp="10rfgtlafpudv">
                50
              </strong>
              <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.12em] text-brand-muted" data-id="element-208" data-mp="r25r2c32cnsx">
                fichas
              </span>
            </div>
            <div className="px-2" data-id="element-209" data-mp="n0sku0w26ilh">
              <strong className="block font-serif text-xl leading-none text-brand-forest" data-id="element-210" data-mp="i1ppj85vrqqp">
                5
              </strong>
              <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.12em] text-brand-muted" data-id="element-211" data-mp="d1bedh8zg0og">
                módulos
              </span>
            </div>
          </div>
          <ul className="mt-3 grid grid-cols-1 gap-x-4 gap-y-1.5 text-[11px] leading-snug text-brand-muted sm:grid-cols-2" data-id="element-212" data-mp="3u5imlbl4okvw">
            <li data-id="element-213" data-mp="2x4qgh03z0sz">
              <span aria-hidden="true" data-id="element-214" data-mp="2wlbn95r8sj6">🫳</span>{' '}
              <strong className="font-semibold text-brand-forest" data-id="element-215" data-mp="7x9aui450foh">
                Dolor y Estructura
              </strong>{' '}
              <span data-id="element-216" data-mp="cw3qxcapzq4w">(Migrañas, espalda, articulaciones)</span>
            </li>
            <li data-id="element-217" data-mp="3bfaoj7wackmk">
              <span aria-hidden="true" data-id="element-218" data-mp="3bfkit7od5dy2">🫧</span>{' '}
              <strong className="font-semibold text-brand-forest" data-id="element-219" data-mp="3gd2rcwygxr5j">
                Mente y Emociones
              </strong>{' '}
              <span data-id="element-220" data-mp="3lbe177ork1nr">(Ansiedad, insomnio, ataques de pánico)</span>
            </li>
            <li data-id="element-221" data-mp="3q3npkja8ctnx">
              <span aria-hidden="true" data-id="element-222" data-mp="3q474dr4l31xq">🌿</span>{' '}
              <strong className="font-semibold text-brand-forest" data-id="element-223" data-mp="3q4ynw3kwp97n">
                Digestión y Vitalidad
              </strong>{' '}
              <span data-id="element-224" data-mp="2xm1jtkja8nad">(Acidez, defensas, fatiga)</span>
            </li>
            <li data-id="element-225" data-mp="2pm5b2p8vb92y">
              <span aria-hidden="true" data-id="element-226" data-mp="2pln4ozshrehb">🌙</span>{' '}
              <strong className="font-semibold text-brand-forest" data-id="element-227" data-mp="2pkc4f9y98ouy">
                Salud Femenina
              </strong>{' '}
              <span data-id="element-228" data-mp="2zbykpkpg9e4k">(Ciclo menstrual, menopausia)</span>
            </li>
            <li className="sm:col-span-2" data-id="element-229" data-mp="2zb6ms38dr4b4">
              <span aria-hidden="true" data-id="element-230" data-mp="2ucbwkg832dgz">✨</span>{' '}
              <strong className="font-semibold text-brand-forest" data-id="element-231" data-mp="2udnah8v8t1lt">
                Estética y Relajación
              </strong>{' '}
              <span data-id="element-232" data-mp="21o7rnwxc64fc">(Lifting natural, bruxismo)</span>
            </li>
          </ul>
          <p className="mt-3 text-sm leading-relaxed text-brand-muted" data-id="element-233" data-mp="21qkf2plv56zs">
            Localización, técnica de presión y acción terapéutica en una
            consulta rápida.
          </p>
        </div>
      </div>
      <div className="mt-14 text-center" data-id="element-234" data-mp="3s0lzcxfp1595">
        <h3 className="flex items-center justify-center gap-2 font-serif text-2xl font-bold text-brand-ink" data-id="element-235" data-mp="3rzawr0xzi3jm">
          <GiftIcon className="h-5 w-5 text-brand-goldDark" aria-hidden="true" data-id="element-236" data-mp="3n1116p8cl0xh" />
          6 BONOS ESTRATÉGICOS —<span className="text-[#47BB37]" data-id="element-237" data-mp="3unej1s1cqhj0">GRATIS</span>
        </h3>
      </div>
      <div className="mx-auto mt-7 grid max-w-6xl grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-238" data-mp="3g213asna021">
        {bonuses.map(bonus => <article key={bonus.n} className="min-w-0" data-id="element-239" data-mp="3plp78a6b1ztv">
            <div className="aspect-[3/4] overflow-hidden rounded-xl border border-brand-gold/40 bg-brand-paper shadow-[0_8px_20px_rgba(34,54,70,0.12)]" data-id="element-240" data-mp="3pm8tg32znadp">
              <img src={bonus.cover} alt={`Portada del bono ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-241" data-mp="m5s06a3fx7zr" />
            </div>
            <p className="mt-2 text-center text-[10px] font-bold uppercase tracking-wide text-brand-purple" data-id="element-242" data-mp="1051cgyoizhyg">
              {bonus.title}
            </p>
            <p className="mt-1 min-h-[3.75rem] text-center text-[10px] leading-tight text-brand-muted" data-id="element-243" data-mp="14wjdtnugnkjy">
              {bonus.description}
            </p>
            <p className="mt-2 text-center text-[10px] text-brand-muted" data-id="element-244" data-mp="benatbnuheic">
              <span className="line-through" data-id="element-245" data-mp="bcakob7xnxu7">{bonus.price}</span>{' '}
              <strong className="text-brand-forest" data-id="element-246" data-mp="6g26p15h2aom">→ GRATIS</strong>
            </p>
          </article>)}
      </div>
      <div className="mt-7 text-center" data-id="element-247" data-mp="1e361z149rvd">
        <span className="inline-block rounded-full border border-brand-gold/50 bg-brand-paper px-5 py-3 text-sm font-medium text-brand-text" data-id="element-248" data-mp="z4hm3osimv0h">
          Valor total bonos{' '}
          <span className="text-brand-muted line-through" data-id="element-249" data-mp="p5s3ftssp6j6">$76.000</span>{' '}
          <strong className="text-brand-forest" data-id="element-250" data-mp="p7v2t4fu8c0k">
            → GRATIS con tu Botiquín Ancestral
          </strong>
        </span>
      </div>
    </Section>;
}
export function MethodOverview() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-251" data-mp="39twm6crjd1bw">
      <Pricing data-id="element-252" data-mp="34w4wzqi9ztbe" />
    </div>;
}